import * as React from 'react';
import RToggle from 'react-toggle';
import styled from 'styled-components';

interface IToggleProps {
  onChange: (value: string | number, checked: boolean) => void;
  name: string;
  label: string;
  value: string | number;
  checked: boolean;
}

export const Toggle = (props: IToggleProps): React.ReactElement => {
  const changeHandler = (e: React.ChangeEvent<HTMLInputElement>): void => {
    e.stopPropagation();
    props.onChange(e.currentTarget.value, e.currentTarget.checked);
  };

  const suppressClickEvent = (e: React.MouseEvent<HTMLElement>): void =>
    e.stopPropagation();

  return (
    <Container onClick={suppressClickEvent}>
      <Label>{props.label}</Label>
      <RToggle
        id='toggle'
        className='toggle'
        name={props.name}
        icons={false}
        checked={props.checked}
        onChange={changeHandler}
        value={props.value}
      />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const Label = styled.label.attrs((props) => ({
  htmlFor: 'toggle',
}))`
  padding-right: 10px;
`;
